<script type="text/javascript">
	// TODO: It might be nice to automatically add <NavPathItem spacer/> between elements, but I haven't been able to figure out how to loop through slots.
</script>
<div>
	<slot/>
</div>
